export const FrontLoggerSymbol = Symbol.for("FrontShipLoggerSymbol");

export type IFrontLogger = {
  getLogger(name: string): IFrontLogger;
  info(obj: Record<string, unknown> | string, msg?: string): void;
  debug(obj: Record<string, unknown> | string, msg?: string): void;
  warn(obj: Record<string, unknown> | string, msg?: string): void;
  error(obj: Record<string, unknown> | string, msg?: string): void;
};

export interface IFrontLoggerShipping {
  shipLog: (message: LoggerMsg, level: string, name: string) => void;
}

export type LoggerMsg = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  obj?: Record<string, any>;
  msg: string;
};

export type LogsQueueType = {
  message: LoggerMsg;
  source: string;
  userAgent: string;
};
